export default "__VITE_ASSET__15c6162e__"